(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["callidus-navigation"] && !Shopify.designMode) return;
  try {
    
  document.documentElement.classList.add('has-callidus-navigation');
  document.querySelectorAll('[data-callidus-nav]').forEach(function (nav) {
    var button = nav.querySelector('.callidus-nav-toggle');
    var menu = nav.querySelector('.callidus-menu');
    if (!button || !menu) return;
    button.addEventListener('click', function () {
      var open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('is-open', !open);
    });

    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-reviews"] && !Shopify.designMode) return;
  try {
    
// No additional JavaScript required

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voltage-drop-calculator"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const calculateButton = document.getElementById('calculate-button');
    calculateButton.addEventListener('click', function () {
      // Debugging check
      console.log('Calculate button clicked');

      const cableArea = document.getElementById('cable_area').value;
      const supplyVoltage = parseFloat(document.getElementById('supply_voltage').value);
      const currentDraw = parseFloat(document.getElementById('current_draw').value);
      const circuitLength = parseFloat(document.getElementById('circuit_length').value);

      // Debugging check
      console.log(`Inputs - Cable Area: ${cableArea}, Supply Voltage: ${supplyVoltage}, Current Draw: ${currentDraw}, Circuit Length: ${circuitLength}`);

      // Resistance per meter values based on provided cable cross-section in ohms/meter
      const resistancePerMeter = {
        "0.35": 0.0544,
        "0.50": 0.03710,
        "0.75": 0.0247,
        "1.00": 0.01850,
        "1.50": 0.01270,
        "2.00": 0.00942,
        "2.50": 0.00760,
        "3.00": 0.00615,
        "4.00": 0.00471,
        "6.00": 0.00314,
        "8.50": 0.00220,
        "10.00": 0.00182,
        "16.00": 0.00126,
        "25.00": 0.00077,
        "35.00": 0.00056,
        "50.00": 0.00039,
        "70.00": 0.00029,
        "95.00": 0.00020,
        "120.00": 0.00015
      };

      const resistance = resistancePerMeter[cableArea];
      const roundTripLength = circuitLength * 2;

      // Voltage Drop calculation
      const voltageDrop = (currentDraw * resistance * roundTripLength).toFixed(2);
      const voltageDropPercent = ((voltageDrop / supplyVoltage) * 100).toFixed(1);

      // Suitability check
      let suitabilityMessage = '';
      let suitabilityClass = '';
      if (voltageDropPercent <= 4) {
        suitabilityMessage = 'This cable size is suitable (within the 3-4% maximum recommended voltage drop).';
        suitabilityClass = 'suitability';
      } else {
        suitabilityMessage = 'This cable size is NOT suitable (exceeds the recommended 3-4% maximum voltage drop).';
        suitabilityClass = 'not-suitable';
      }

      // Display results
      document.querySelector('.result').innerHTML = `
        <p>The voltage drop is ${voltageDropPercent}% (${voltageDrop} volts).</p>
        <p>Calculated using a resistance of ${resistance}Ω per metre for the cable, and a total round-trip circuit length of ${roundTripLength} metres.</p>
        <p class="${suitabilityClass}">${suitabilityMessage}</p>
      `;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
